import { render, staticRenderFns } from "./boothRentalRateList.vue?vue&type=template&id=a6738d54&scoped=true&"
import script from "./boothRentalRateList.vue?vue&type=script&lang=js&"
export * from "./boothRentalRateList.vue?vue&type=script&lang=js&"
import style0 from "./boothRentalRateList.vue?vue&type=style&index=0&id=a6738d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6738d54",
  null
  
)

export default component.exports